import Rover from '@rover/globals/Rover';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import $ from '@rover/globals/jquery';
import inject from '@rover/utilities/injector';

export default Backbone.View.extend({
  PAGE_TITLE: window.document.title,

  initialize(options) {
    // Bail if browser does not support history API
    if (!window.history || !history.pushState) {
      return;
    }

    this.query = options.query;
    this.searchResults = options.searchResults;
    this.serviceTypes = options.serviceTypes;

    // whether or not the history manager caused the
    // state to change
    this.updatingState = false;

    // Update history on searchResults changes
    this.searchResults.on('change', _.bind(this.onSearchResultsChanged, this));

    // Update query on window state change
    $(window).on('popstate', _.bind(this.onWindowStateChange, this));

    // Listen to requests to set the root url
    Rover.pubSub.on('history:resetToRootUrl', _.bind(this.resetToRootUrl, this));
  },

  resetToRootUrl() {
    const url = Rover.searchRouter.getRoot();
    this.updatingState = true;
    history.replaceState({}, this.PAGE_TITLE, url + window.location.search);
  },

  onWindowStateChange() {
    if (this.updatingState) {
      this.updatingState = false;
      return;
    }

    this.updatingState = true;
    this.query.set(history.state);
  },

  getNonDefaultParams(params) {
    const initial = inject('Rover.initialFormValues', {});
    const newParams = {};

    _.each(params, (value, key) => {
      if (initial[key] !== value) {
        newParams[key] = value;
      }
    });

    if (window.location.pathname !== '/search/') {
      delete newParams.location;
      delete newParams.centerlat;
      delete newParams.centerlng;
      delete newParams.service_type;
    }
    return newParams;
  },

  onSearchResultsChanged() {
    if (this.updatingState) {
      this.updatingState = false;
      return;
    }

    // We update the history with the data from the
    // actual query that was done.
    let originalParams = this.searchResults.get('query'),
      params = this.getNonDefaultParams(originalParams),
      url = '',
      serviceType = _.findWhere(this.serviceTypes, {
        slug: originalParams.service_type,
      });

    // Build the URL
    if (!$.isEmptyObject(params)) {
      url += `?${$.param(params, true)}`;
    }
    if (window.location.hash !== '#') {
      url += window.location.hash;
    }

    if (serviceType && serviceType.seo_url) {
      url = serviceType.seo_url + url;
    }

    if (params) {
      history.pushState(params, this.PAGE_TITLE, url);
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/utilities/search/history_manager.js